import {getAuthorInfo} from '@/api/user'
import router from '@/router'
import {
	removeCookieToken,
	getCookieToken,
	TokenKey,
	removeCookieUd,
	setSdAndUd,
	setUserInfo
} from '@/utils/auth'

const user = {
	namespaced: true,
	state: {
		userInfo: null,
		userStatus: ''
	},
	getters: {
		getUserInfo(state) {
			return state.userInfo && Object.assign({}, state.userInfo, state.userInfo.authorInfo)
		},
		getToken() {
			return getCookieToken()
		}

	},
	mutations: {
		getUserMutation: (state, user) => {
			// 保存用户信息
			state.userInfo = user
			setUserInfo(user)
		},
		logoutMutaion: (state) => {
			state.userInfo = null
			// 清空token
			state.token = null
			// 删除cookie中的Token
			removeCookieToken()
			removeCookieUd()
		},
		loginMutaion: (state, data) => {
			let token = data.header[TokenKey]
			setSdAndUd(token)
			// 保存token
			// state.token =token
		},
		setUserStatus: (state, status) => {
			state.userStatus = status
			if (status === 'unregister') {
				router.push({name: 'register'})
			}
		}

	},

	actions: {

		// 获取用户信息
		async fetchUserInfo({commit, state}) {
			let result = await getAuthorInfo()

			return new Promise((resolve, reject) => {
				if (result.data.items) {
					commit('getUserMutation', result.data.items)
					let cpId = result.data.items.cpId ||
						 (result.data.items.authorInfo && result.data.items.authorInfo.cpId)
					commit('app/setSite', cpId, {root: true})

					resolve(result.data.items)
				} else {
					reject()
				}
			})
		}
	}
}
export default user



// WEBPACK FOOTER //
// ./src/store/user.js